@import 'npm:@yleisradio/yds-core/tokens/css/_theme-default.css';
@import 'npm:@yleisradio/yds-core/tokens/css/_shadow-default.css';

.app {
  color: var(--text-primary);
  display: flex;
  flex-direction: column;
  flex: 1;
}
